import * as ambassadorWixEcommerceCurrencyConverterV1CurrencyRate from './ecommerce-currency-converter-v1-currency-rate-currencies.http.js';
import * as ambassadorWixEcommerceCurrencyConverterV1CurrencyRateTypes from './ecommerce-currency-converter-v1-currency-rate-currencies.types.js';
import * as ambassadorWixEcommerceCurrencyConverterV1CurrencyRateUniversalTypes from './ecommerce-currency-converter-v1-currency-rate-currencies.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listCurrencies(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateUniversalTypes.ListCurrenciesRequest,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateTypes.ListCurrenciesRequest,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateUniversalTypes.ListCurrenciesResponse,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateTypes.ListCurrenciesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcommerceCurrencyConverterV1CurrencyRate.listCurrencies(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/currencies',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function convertCurrency(): __PublicMethodMetaInfo<
  'POST',
  { from: string; to: string },
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateUniversalTypes.ConvertCurrencyRequest,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateTypes.ConvertCurrencyRequest,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateUniversalTypes.ConvertCurrencyResponse,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateTypes.ConvertCurrencyResponse
> {
  const payload = { from: ':from', to: ':to' } as any;

  const getRequestOptions =
    ambassadorWixEcommerceCurrencyConverterV1CurrencyRate.convertCurrency(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/currencies/amounts/{from}/convert/{to}',
    pathParams: { from: 'from', to: 'to' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getConversionRate(): __PublicMethodMetaInfo<
  'GET',
  { from: string; to: string },
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateUniversalTypes.ConversionRateRequest,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateTypes.ConversionRateRequest,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateUniversalTypes.ConversionRateResponse,
  ambassadorWixEcommerceCurrencyConverterV1CurrencyRateTypes.ConversionRateResponse
> {
  const payload = { from: ':from', to: ':to' } as any;

  const getRequestOptions =
    ambassadorWixEcommerceCurrencyConverterV1CurrencyRate.conversionRate(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/currencies/rate/{from}/convert/{to}',
    pathParams: { from: 'from', to: 'to' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CurrencyRate as CurrencyRateOriginal,
  ListCurrenciesRequest as ListCurrenciesRequestOriginal,
  ListCurrenciesResponse as ListCurrenciesResponseOriginal,
  Currency as CurrencyOriginal,
  ConvertCurrencyRequest as ConvertCurrencyRequestOriginal,
  DecimalValue as DecimalValueOriginal,
  ConvertCurrencyResponse as ConvertCurrencyResponseOriginal,
  ConversionRateRequest as ConversionRateRequestOriginal,
  ConversionRateResponse as ConversionRateResponseOriginal,
} from './ecommerce-currency-converter-v1-currency-rate-currencies.types.js';
